import { RequiredActionsSectionProps } from './types';
import { getUserActionRoute, UserActionResponse, UserActionsSection } from '@/features/UserAction';
import { useNavigate } from 'react-router-dom';

const RequiredActionsSection = (props: RequiredActionsSectionProps) => {
  const {
    isError,
    items
  } = props;

  const navigate = useNavigate();

  const onClickUserAction = (action: UserActionResponse): void => {
    if (action.code === 'CONFIRM_SHIPMENT_DETAILS') {
      const route = getUserActionRoute({ action });

      if (route) {
        navigate(route);
        return;
      }
    }

    if (
      action.subject.type === 'ORGANIZATION' &&
      (action.code === 'ADD_MCHD' || action.code === 'UPDATE_MCHD')
    ) {
      navigate('/profile');
      return;
    }

    if (action.code === 'DECIDE_UNRELEASED_ITEM') {
      const route = getUserActionRoute({
        action,
        context: { source: 'main' }
      });

      if (route) {
        navigate(route);
        return;
      }
    }

    navigate(`/shipments/${encodeURIComponent(action.subject.id)}`);
  };

  return (
    <UserActionsSection
      isError={isError}
      items={items}
      onClick={onClickUserAction}
      variant="main"
    />
  );
};

export default RequiredActionsSection;